module.exports = __webpack_public_path__ + "static/media/Reasons For Life Insurance in Retirement.2e0b0ef8.pdf";